import { sessionStorage, tossLocalStorage, storageKeys } from "@/utils/storage";

interface BuildCallLeadMemoParams {
  trigger: string;
  reason?: string;
  experience?: string;
  utm?: {
    source?: string;
    medium?: string;
    campaign?: string;
    content?: string;
    term?: string;
  };
  extraInfo?: string;
}

export function buildCallLeadMemo({
  trigger,
  reason,
  experience,
  utm,
  extraInfo,
}: BuildCallLeadMemoParams): string {
  const lines: string[] = [
    "[상담 정보]",
    `[상담 진입] ${trigger}`,
    `[고객 질문] ${reason ?? "X"}`,
    `[참고 정보] ${extraInfo ?? "X"}`,
  ];

  if (experience) {
    lines.push(`[장례 경험] ${experience}`);
  }

  if (utm) {
    const utmParts = Object.entries(utm)
      .filter(([, v]) => v)
      .map(([k, v]) => `${k}=${v}`);
    if (utmParts.length > 0) {
      lines.push(`[UTM] ${utmParts.join(" / ")}`);
    }
  }

  const isRegistered =
    tossLocalStorage.get(storageKeys.IsRegistered) === "true";
  if (isRegistered) {
    lines.push("[가입 여부] O");
  }

  const visitCount = tossLocalStorage.get(storageKeys.DirectVisitCount);
  if (visitCount && Number(visitCount) > 0) {
    lines.push(`[방문 횟수] ${visitCount}회`);
  }

  const gender = sessionStorage.get(storageKeys.Gender);
  const birthdate = sessionStorage.get(storageKeys.Birthdate);
  const customerParts: string[] = [];
  if (gender) customerParts.push(gender);
  if (birthdate && birthdate.length >= 4) {
    const age = new Date().getFullYear() - parseInt(birthdate.slice(0, 4), 10);
    customerParts.push(`${age}세`);
  }
  if (customerParts.length > 0) {
    lines.push(`[고객 정보] ${customerParts.join(" / ")}`);
  }

  return lines.join("\n");
}
